import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const loginUser = createAsyncThunk('loginUser', async (object, { rejectWithValue }) => {
  const response = await request('/api/v1/tenant/user-login', { method: 'POST', body: object });
  console.log('response :', response);

  if (response?.status) {
    return response;
  }
  const { error } = response;
  throw rejectWithValue(error || 'Something went wrong');
});